module.exports = __webpack_public_path__ + "static/media/screen-moncompte.a9eb4a46.png";